module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-slider"
  }, [_c('div', {
    staticClass: "image-prev",
    on: {
      "click": function($event) {
        return _vm.prev()
      }
    }
  }, [_c('icons', {
    attrs: {
      "icon": "chevron-left"
    }
  })], 1), _vm._v(" "), _c('v-touch', {
    on: {
      "swipeleft": function($event) {
        return _vm.next()
      },
      "swiperight": function($event) {
        return _vm.prev()
      }
    }
  }, [_c('div', {
    staticClass: "image-container",
    style: ({
      'margin-left': _vm.currentOffset + 'px',
      'max-width': _vm.width + 'px'
    })
  }, _vm._l((_vm.images), function(image) {
    return _c('img', {
      attrs: {
        "src": image
      }
    })
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "image-next",
    on: {
      "click": function($event) {
        return _vm.next()
      }
    }
  }, [_c('icons', {
    attrs: {
      "icon": "chevron-right"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42fe18e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImageSlider.vue
// module id = 217
// module chunks = 1